export default __webpack_public_path__ + "static/media/dashboard.33c681b8.svg";